import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 px-6 md:pt-32 md:pb-20 max-w-4xl mx-auto text-center" data-id="element-35">
      <motion.h1 initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-4xl md:text-6xl font-black tracking-tight text-black mb-8 leading-[1.1]" data-id="element-36">
        Deja de disculparte por existir. Hackea tu ansiedad social en el trabajo
        con los 50+ "Scripts de Supervivencia" diseñados para la Gen Z.
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-37">
        Cómo dominar reuniones de Zoom, presentaciones de equipo y el "Small
        Talk" de oficina sin que nadie note que quieres desaparecer de la
        Tierra. Olvida la terapia de 6 meses; usa soluciones de 15 segundos.
      </motion.p>

      <motion.a href="#pricing" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.25
    }} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} className="inline-flex items-center gap-3 mt-10 bg-black text-white px-8 py-4 rounded-2xl text-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 group" onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }} data-id="element-38">
        OBTENER ACCESO — $6.39
        <ArrowDownIcon className="w-5 h-5 group-hover:translate-y-1 transition-transform" data-id="element-39" />
      </motion.a>
    </section>;
}